import React from "react";

type MetaTag = {
  itemProp: string;
  content?: string;
};

type MetaTagsProps = {
  tags: MetaTag[];
};

export const MetaTags = ({ tags }: MetaTagsProps) => {
  return (
    <>
      {tags.map((tag) => (
        <meta key={tag.itemProp} {...tag} />
      ))}
    </>
  );
};
